import { all, takeLatest } from "redux-saga/effects";

import {
  CHANGE_REPERTOIRE_STATUS_REQUEST,
  CREATE_REPERTOIRE_REQUEST,
  DELETE_REPERTOIRE_REQUEST,
  GET_ACCESSIBLE_REPERTOIRE_TREE_REQUEST,
  GET_ALL_REPERTOIRES_REQUEST,
  GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST,
  GET_REPERTOIRE_BREADCRUMB_REQUEST,
  GET_REPERTOIRE_CONTEXT_REQUEST,
  GET_REPERTOIRE_REQUEST,
  GET_REPERTOIRE_TREE_REQUEST,
  GET_REPERTOIRES_BY_STATUS_REQUEST,
  UPDATE_REPERTOIRE_REQUEST,
} from "../../actions/repertoireActions";
import {
  changeRepertoireStatusSaga,
  createRepertoireSaga,
  deleteRepertoireSaga,
  getAccessibleRepertoireTreeSaga,
  getAllRepertoiresSaga,
  getAuthorizedRepertoireTreeSaga,
  getRepertoireBreadcrumbSaga,
  getRepertoireContextSaga,
  getRepertoireSaga,
  getRepertoireTreeSaga,
  getRepertoiresByStatusSaga,
  updateRepertoireSaga,
} from "../../sagas/repertoireSaga";

import {
  APPROVE_KMS_CONTENT_REQUEST,
  ARCHIVE_KMS_CONTENT_REQUEST,
  CHANGE_KMS_CONTENT_STATUS_REQUEST,
  CREATE_KMS_CONTENT_COMMENT_REQUEST,
  CREATE_KMS_CONTENT_REQUEST,
  DELETE_KMS_CONTENT_COMMENT_REQUEST,
  DELETE_KMS_CONTENT_REQUEST,
  GENERATE_KMS_ARTICLE_DRAFT_REQUEST,
  GET_KMS_ARCHIVED_CONTENTS_REQUEST,
  GET_KMS_CONTENT_COMMENTS_REQUEST,
  GET_KMS_CONTENT_RATING_SUMMARY_REQUEST,
  GET_KMS_CONTENT_REQUEST,
  GET_KMS_CONTENT_SUBSCRIPTION_REQUEST,
  GET_KMS_CONTENT_WORKFLOW_HISTORY_REQUEST,
  GET_KMS_CONTENTS_BY_REPERTOIRE_REQUEST,
  GET_KMS_CONTENTS_REQUEST,
  GET_KMS_TRASHED_CONTENTS_REQUEST,
  HARD_DELETE_KMS_CONTENT_REQUEST,
  PUBLISH_KMS_CONTENT_REQUEST,
  REJECT_KMS_CONTENT_REQUEST,
  RESTORE_KMS_CONTENT_FROM_ARCHIVE_REQUEST,
  RESTORE_KMS_CONTENT_FROM_TRASH_REQUEST,
  RETURN_KMS_CONTENT_TO_DRAFT_REQUEST,
  SUBMIT_KMS_CONTENT_REQUEST,
  SUBSCRIBE_KMS_CONTENT_REQUEST,
  UNSUBSCRIBE_KMS_CONTENT_REQUEST,
  UPDATE_KMS_CONTENT_REQUEST,
  UPSERT_KMS_CONTENT_RATING_REQUEST,
} from "../../actions/kmsContentActions";
import {
  approveKmsContentSaga,
  archiveKmsContentSaga,
  changeKmsContentStatusSaga,
  createKmsContentCommentSaga,
  createKmsContentSaga,
  deleteKmsContentCommentSaga,
  deleteKmsContentSaga,
  generateKmsArticleDraftSaga,
  getKmsArchivedContentsSaga,
  getKmsContentCommentsSaga,
  getKmsContentRatingSummarySaga,
  getKmsContentSaga,
  getKmsContentSubscriptionSaga,
  getKmsContentWorkflowHistorySaga,
  getKmsContentsByRepertoireSaga,
  getKmsContentsSaga,
  getKmsTrashedContentsSaga,
  hardDeleteKmsContentSaga,
  publishKmsContentSaga,
  rejectKmsContentSaga,
  restoreKmsContentFromArchiveSaga,
  restoreKmsContentFromTrashSaga,
  returnKmsContentToDraftSaga,
  submitKmsContentSaga,
  subscribeKmsContentSaga,
  unsubscribeKmsContentSaga,
  updateKmsContentSaga,
  upsertKmsContentRatingSaga,
} from "../../sagas/kmsContentSaga";

import {
  APPROVE_KMS_DOCUMENT_REQUEST,
  ARCHIVE_KMS_DOCUMENT_REQUEST,
  CREATE_KMS_DOCUMENT_COMMENT_REQUEST,
  DELETE_KMS_DOCUMENT_COMMENT_REQUEST,
  DELETE_KMS_DOCUMENT_REQUEST,
  GET_KMS_ARCHIVED_DOCUMENTS_REQUEST,
  GET_KMS_DOCUMENT_COMMENTS_REQUEST,
  GET_KMS_DOCUMENT_RATING_SUMMARY_REQUEST,
  GET_KMS_DOCUMENT_REQUEST,
  GET_KMS_DOCUMENT_SUBSCRIPTION_REQUEST,
  GET_KMS_DOCUMENTS_BY_CONTENT_REQUEST,
  GET_KMS_DOCUMENTS_BY_REPERTOIRE_REQUEST,
  GET_KMS_DOCUMENTS_REQUEST,
  GET_KMS_TRASHED_DOCUMENTS_REQUEST,
  HARD_DELETE_KMS_DOCUMENT_REQUEST,
  PUBLISH_KMS_DOCUMENT_REQUEST,
  REJECT_KMS_DOCUMENT_REQUEST,
  RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_REQUEST,
  RESTORE_KMS_DOCUMENT_FROM_TRASH_REQUEST,
  RETURN_KMS_DOCUMENT_TO_DRAFT_REQUEST,
  SUBMIT_KMS_DOCUMENT_REQUEST,
  SUBSCRIBE_KMS_DOCUMENT_REQUEST,
  UNSUBSCRIBE_KMS_DOCUMENT_REQUEST,
  UPLOAD_KMS_DOCUMENT_TO_CONTENT_REQUEST,
  UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_REQUEST,
  UPDATE_KMS_DOCUMENT_REQUEST,
  UPSERT_KMS_DOCUMENT_RATING_REQUEST,
} from "../../actions/kmsDocumentActions";
import {
  approveKmsDocumentSaga,
  archiveKmsDocumentSaga,
  createKmsDocumentCommentSaga,
  deleteKmsDocumentCommentSaga,
  deleteKmsDocumentSaga,
  getKmsArchivedDocumentsSaga,
  getKmsDocumentCommentsSaga,
  getKmsDocumentSaga,
  getKmsDocumentRatingSummarySaga,
  getKmsDocumentSubscriptionSaga,
  getKmsDocumentsByContentSaga,
  getKmsDocumentsByRepertoireSaga,
  getKmsDocumentsSaga,
  getKmsTrashedDocumentsSaga,
  hardDeleteKmsDocumentSaga,
  publishKmsDocumentSaga,
  rejectKmsDocumentSaga,
  restoreKmsDocumentFromArchiveSaga,
  restoreKmsDocumentFromTrashSaga,
  returnKmsDocumentToDraftSaga,
  submitKmsDocumentSaga,
  subscribeKmsDocumentSaga,
  unsubscribeKmsDocumentSaga,
  uploadKmsDocumentToContentSaga,
  uploadKmsDocumentToRepertoireSaga,
  updateKmsDocumentSaga,
  upsertKmsDocumentRatingSaga,
} from "../../sagas/kmsDocumentSaga";

import { SEARCH_KMS_REQUEST } from "../../actions/kmsSearchActions";
import { searchKmsSaga } from "../../sagas/kmsSearchSaga";

import {
  CREATE_KMS_CATEGORY_REQUEST,
  CREATE_KMS_TAG_REQUEST,
  DELETE_KMS_CATEGORY_REQUEST,
  DELETE_KMS_TAG_REQUEST,
  GET_KMS_CATEGORIES_REQUEST,
  GET_KMS_TAGS_REQUEST,
  GET_KMS_TAXONOMY_OPTIONS_REQUEST,
  TOGGLE_KMS_CATEGORY_ACTIVE_REQUEST,
  UPDATE_KMS_CATEGORY_REQUEST,
  UPDATE_KMS_TAG_REQUEST,
} from "../../actions/kmsTaxonomyActions";
import {
  createKmsCategorySaga,
  createKmsTagSaga,
  deleteKmsCategorySaga,
  deleteKmsTagSaga,
  getKmsCategoriesSaga,
  getKmsTagsSaga,
  getKmsTaxonomyOptionsSaga,
  toggleKmsCategoryActiveSaga,
  updateKmsCategorySaga,
  updateKmsTagSaga,
} from "../../sagas/kmsTaxonomySaga";

export default function* kmsRootSaga() {
  yield all([
    takeLatest(GET_REPERTOIRE_REQUEST, getRepertoireSaga),
    takeLatest(GET_ALL_REPERTOIRES_REQUEST, getAllRepertoiresSaga),
    takeLatest(GET_REPERTOIRE_TREE_REQUEST, getRepertoireTreeSaga),
    takeLatest(GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST, getAuthorizedRepertoireTreeSaga),
    takeLatest(GET_ACCESSIBLE_REPERTOIRE_TREE_REQUEST, getAccessibleRepertoireTreeSaga),
    takeLatest(GET_REPERTOIRE_CONTEXT_REQUEST, getRepertoireContextSaga),
    takeLatest(GET_REPERTOIRE_BREADCRUMB_REQUEST, getRepertoireBreadcrumbSaga),
    takeLatest(GET_REPERTOIRES_BY_STATUS_REQUEST, getRepertoiresByStatusSaga),
    takeLatest(CREATE_REPERTOIRE_REQUEST, createRepertoireSaga),
    takeLatest(UPDATE_REPERTOIRE_REQUEST, updateRepertoireSaga),
    takeLatest(CHANGE_REPERTOIRE_STATUS_REQUEST, changeRepertoireStatusSaga),
    takeLatest(DELETE_REPERTOIRE_REQUEST, deleteRepertoireSaga),

    takeLatest(GET_KMS_CONTENTS_REQUEST, getKmsContentsSaga),
    takeLatest(GET_KMS_ARCHIVED_CONTENTS_REQUEST, getKmsArchivedContentsSaga),
    takeLatest(GET_KMS_TRASHED_CONTENTS_REQUEST, getKmsTrashedContentsSaga),
    takeLatest(GET_KMS_CONTENTS_BY_REPERTOIRE_REQUEST, getKmsContentsByRepertoireSaga),
    takeLatest(GET_KMS_CONTENT_REQUEST, getKmsContentSaga),
    takeLatest(GET_KMS_CONTENT_WORKFLOW_HISTORY_REQUEST, getKmsContentWorkflowHistorySaga),
    takeLatest(GET_KMS_CONTENT_COMMENTS_REQUEST, getKmsContentCommentsSaga),
    takeLatest(GET_KMS_CONTENT_SUBSCRIPTION_REQUEST, getKmsContentSubscriptionSaga),
    takeLatest(GET_KMS_CONTENT_RATING_SUMMARY_REQUEST, getKmsContentRatingSummarySaga),
    takeLatest(CREATE_KMS_CONTENT_REQUEST, createKmsContentSaga),
    takeLatest(CREATE_KMS_CONTENT_COMMENT_REQUEST, createKmsContentCommentSaga),
    takeLatest(UPSERT_KMS_CONTENT_RATING_REQUEST, upsertKmsContentRatingSaga),
    takeLatest(GENERATE_KMS_ARTICLE_DRAFT_REQUEST, generateKmsArticleDraftSaga),
    takeLatest(UPDATE_KMS_CONTENT_REQUEST, updateKmsContentSaga),
    takeLatest(CHANGE_KMS_CONTENT_STATUS_REQUEST, changeKmsContentStatusSaga),
    takeLatest(SUBMIT_KMS_CONTENT_REQUEST, submitKmsContentSaga),
    takeLatest(APPROVE_KMS_CONTENT_REQUEST, approveKmsContentSaga),
    takeLatest(REJECT_KMS_CONTENT_REQUEST, rejectKmsContentSaga),
    takeLatest(PUBLISH_KMS_CONTENT_REQUEST, publishKmsContentSaga),
    takeLatest(ARCHIVE_KMS_CONTENT_REQUEST, archiveKmsContentSaga),
    takeLatest(RETURN_KMS_CONTENT_TO_DRAFT_REQUEST, returnKmsContentToDraftSaga),
    takeLatest(DELETE_KMS_CONTENT_REQUEST, deleteKmsContentSaga),
    takeLatest(DELETE_KMS_CONTENT_COMMENT_REQUEST, deleteKmsContentCommentSaga),
    takeLatest(SUBSCRIBE_KMS_CONTENT_REQUEST, subscribeKmsContentSaga),
    takeLatest(UNSUBSCRIBE_KMS_CONTENT_REQUEST, unsubscribeKmsContentSaga),
    takeLatest(RESTORE_KMS_CONTENT_FROM_ARCHIVE_REQUEST, restoreKmsContentFromArchiveSaga),
    takeLatest(RESTORE_KMS_CONTENT_FROM_TRASH_REQUEST, restoreKmsContentFromTrashSaga),
    takeLatest(HARD_DELETE_KMS_CONTENT_REQUEST, hardDeleteKmsContentSaga),

    takeLatest(GET_KMS_DOCUMENTS_BY_REPERTOIRE_REQUEST, getKmsDocumentsByRepertoireSaga),
    takeLatest(GET_KMS_DOCUMENTS_BY_CONTENT_REQUEST, getKmsDocumentsByContentSaga),
    takeLatest(GET_KMS_DOCUMENTS_REQUEST, getKmsDocumentsSaga),
    takeLatest(GET_KMS_ARCHIVED_DOCUMENTS_REQUEST, getKmsArchivedDocumentsSaga),
    takeLatest(GET_KMS_TRASHED_DOCUMENTS_REQUEST, getKmsTrashedDocumentsSaga),
    takeLatest(GET_KMS_DOCUMENT_REQUEST, getKmsDocumentSaga),
    takeLatest(GET_KMS_DOCUMENT_COMMENTS_REQUEST, getKmsDocumentCommentsSaga),
    takeLatest(GET_KMS_DOCUMENT_SUBSCRIPTION_REQUEST, getKmsDocumentSubscriptionSaga),
    takeLatest(GET_KMS_DOCUMENT_RATING_SUMMARY_REQUEST, getKmsDocumentRatingSummarySaga),
    takeLatest(CREATE_KMS_DOCUMENT_COMMENT_REQUEST, createKmsDocumentCommentSaga),
    takeLatest(DELETE_KMS_DOCUMENT_COMMENT_REQUEST, deleteKmsDocumentCommentSaga),
    takeLatest(SUBSCRIBE_KMS_DOCUMENT_REQUEST, subscribeKmsDocumentSaga),
    takeLatest(UNSUBSCRIBE_KMS_DOCUMENT_REQUEST, unsubscribeKmsDocumentSaga),
    takeLatest(UPSERT_KMS_DOCUMENT_RATING_REQUEST, upsertKmsDocumentRatingSaga),
    takeLatest(UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_REQUEST, uploadKmsDocumentToRepertoireSaga),
    takeLatest(UPLOAD_KMS_DOCUMENT_TO_CONTENT_REQUEST, uploadKmsDocumentToContentSaga),
    takeLatest(UPDATE_KMS_DOCUMENT_REQUEST, updateKmsDocumentSaga),
    takeLatest(SUBMIT_KMS_DOCUMENT_REQUEST, submitKmsDocumentSaga),
    takeLatest(APPROVE_KMS_DOCUMENT_REQUEST, approveKmsDocumentSaga),
    takeLatest(REJECT_KMS_DOCUMENT_REQUEST, rejectKmsDocumentSaga),
    takeLatest(RETURN_KMS_DOCUMENT_TO_DRAFT_REQUEST, returnKmsDocumentToDraftSaga),
    takeLatest(PUBLISH_KMS_DOCUMENT_REQUEST, publishKmsDocumentSaga),
    takeLatest(ARCHIVE_KMS_DOCUMENT_REQUEST, archiveKmsDocumentSaga),
    takeLatest(DELETE_KMS_DOCUMENT_REQUEST, deleteKmsDocumentSaga),
    takeLatest(RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_REQUEST, restoreKmsDocumentFromArchiveSaga),
    takeLatest(RESTORE_KMS_DOCUMENT_FROM_TRASH_REQUEST, restoreKmsDocumentFromTrashSaga),
    takeLatest(HARD_DELETE_KMS_DOCUMENT_REQUEST, hardDeleteKmsDocumentSaga),

    takeLatest(SEARCH_KMS_REQUEST, searchKmsSaga),

    takeLatest(GET_KMS_TAXONOMY_OPTIONS_REQUEST, getKmsTaxonomyOptionsSaga),
    takeLatest(GET_KMS_CATEGORIES_REQUEST, getKmsCategoriesSaga),
    takeLatest(GET_KMS_TAGS_REQUEST, getKmsTagsSaga),
    takeLatest(CREATE_KMS_CATEGORY_REQUEST, createKmsCategorySaga),
    takeLatest(UPDATE_KMS_CATEGORY_REQUEST, updateKmsCategorySaga),
    takeLatest(TOGGLE_KMS_CATEGORY_ACTIVE_REQUEST, toggleKmsCategoryActiveSaga),
    takeLatest(DELETE_KMS_CATEGORY_REQUEST, deleteKmsCategorySaga),
    takeLatest(CREATE_KMS_TAG_REQUEST, createKmsTagSaga),
    takeLatest(UPDATE_KMS_TAG_REQUEST, updateKmsTagSaga),
    takeLatest(DELETE_KMS_TAG_REQUEST, deleteKmsTagSaga),
  ]);
}
